import { bodyRegularStyle } from '@gassan-ui'
import styled from 'styled-components'

export const Question = styled.a`
  ${bodyRegularStyle};
  color: ${p => p.theme.colors.shades[800]};
  border-bottom: 1px solid currentColor;
  line-height: 1.5;
  padding-bottom: 3px;

  &:hover {
    color: ${p => p.theme.colors.tabaccoBrown};
  }
`
